import axios from 'axios'
import { fetchWrapper } from '../../../reducers/fetch'
import { UserCoupon } from '../../UserCoupons/userCoupons.slice'

export const FETCH_TAX_CONSULTATION_URL = 'FETCH_TAX_CONSULTATION_URL'
/**
 * Taxfyle link expires after 5 minutes
 */
export const fetchTaxConsultationUrl = (jobId: string) =>
  fetchWrapper({
    fetchKey: FETCH_TAX_CONSULTATION_URL,
    fetchFunction: async () => {
      const json = await axios.get<{ link: string }>(
        `/finances/api/v1/tax_consultations/${jobId}/link`
      )
      return json.data.link
    },
  })

export const FETCH_NEXT_TAX_CONSULTATION_COUPON_KEY =
  'FETCH_NEXT_TAX_CONSULTATION_COUPON_KEY'
export const fetchNextTaxConsultationCoupon = () =>
  fetchWrapper({
    fetchKey: FETCH_NEXT_TAX_CONSULTATION_COUPON_KEY,
    fetchFunction: async () => {
      const json = await axios.get<UserCoupon | null>(
        '/finances/api/v1/tax_consultations/coupon'
      )
      return json.data
    },
  })

export const FETCH_TAX_CONSULTATION_CHECKOUT_SESSION_KEY =
  'FETCH_TAX_CONSULTATION_CHECKOUT_SESSION_KEY'
export const fetchTaxConsultationCheckoutSession = (duration: 30 | 60) =>
  fetchWrapper({
    fetchKey: FETCH_TAX_CONSULTATION_CHECKOUT_SESSION_KEY,
    fetchFunction: async () => {
      const json = await axios.put<{
        url: string
        internal: boolean
      }>(`/finances/api/v1/tax_consultations/request/duration/${duration}`)
      return json.data
    },
  })
